
import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const SimpleLineChart: React.FC<{ data: number[],color:string }> = ({ data,color }) => {
  const chartContainer = useRef<HTMLCanvasElement>(null);
  const chartInstance = useRef<Chart>();

  useEffect(() => {
    // Cleanup function to destroy the chart instance when the component is unmounted
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  useEffect(() => {
    // Check if chart container and data are available
    if (chartContainer.current && data) {
      const ctx = chartContainer.current.getContext("2d");
      if (ctx) {
        const lastBarColor =
          color === "red"
            ? "#F12222"
            : color === "green"
            ? "#00A651"
            : color === "yellow"
            ? "#FF9F43"
            : "#00A651";

        // Destroy previous chart instance if exists
        if (chartInstance.current) {
          chartInstance.current.destroy();
        }

        // Create new chart instance
        chartInstance.current = new Chart(ctx, {
          type: "bar",
          data: {
            labels: Array.from({ length: data.length }, (_, i) =>
              (i + 1).toString()
            ),
            datasets: [
              {
                label: "Data",
                data: data,
                barPercentage: 0.6,
                categoryPercentage: 0.9,
                backgroundColor: data.map((_, i) =>
                  i === data.length - 1
                    ? lastBarColor
                    : color === "green"
                    ? "#A3DFC0"
                    : color === "red"
                    ? "#FFCECE"
                    : color === "yellow"
                    ? "#FFF0CE"
                    : "#A3DFC0"
                ),
                borderWidth: 1,
                borderRadius: {
                  topLeft: 4.98,
                  topRight: 4.98,
                  bottomLeft: 0,
                  bottomRight: 0,
                },
              },
            ],
          },
          options: {
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
            scales: {
              x: {
                display: false,
              },
              y: {
                beginAtZero: true,
                display: false,
              },
            },
          },
        });
      }
    }
  }, [data]);

  return <canvas ref={chartContainer} />;
};

export default SimpleLineChart;
